import axios from "../axios";
import { setAlert } from "actions/alert";
import { setErrorsList } from "actions/errors";
import {
  SERVICE_CREATED,
  SERVICE_ERROR,
  DELETE_SERVICE,
  SERVICE_UPDATED,
  SERVICE_LIST_UPDATED,
  GET_SERVICE_BY_ID,
  SERVICE_SEARCH_PARAMATERS_UPDATE,
  REMOVE_ERRORS,
  CHANGE_SERVICE_STATUS,
  LOADING_ON_SERVICE_SUBMIT,
  LOADING_SERVICE_LIST_DATA,
  LOAD_PAGE,
  RESET,
} from "actions/types";
import { logout } from "actions/auth";
import { SERVICE } from "constants/api";

//get Service Template list

export const getServiceList =
  (serviceParams) => async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      dispatch({ type: REMOVE_ERRORS });
      dispatch({ type: LOADING_SERVICE_LIST_DATA });
      const query = serviceParams.query ? serviceParams.query : "";
      serviceParams.query = query;
      serviceParams.page = serviceParams.page
        ? serviceParams.page
        : 1;

      config.params = serviceParams;
      const res = await axios.get(SERVICE.LIST().ENDPOINT, config);
      // dispatch({ type: REMOVE_ALERT });

      dispatch({
        type: SERVICE_SEARCH_PARAMATERS_UPDATE,
        payload: serviceParams,
      });
      dispatch({
        type: SERVICE_LIST_UPDATED,
        payload: res.data.response[0],
      });
      return res.data ? res.data : { status: false };
    } catch (err) {
      // console.log(err);
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch({
            type: SERVICE_ERROR,
            payload: {
              msg: err.response.statusText,
              status: err.response.status,
            },
          });
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

// Get email template by id
export const getServiceById = (service_id) => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
  dispatch(loadingOnServiceSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(
      `${SERVICE.LIST().ENDPOINT}/${service_id}`,
      config
    );
    // dispatch({ type: REMOVE_ALERT });

    await dispatch({
      type: GET_SERVICE_BY_ID,
      payload: res.data.response,
    });
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    // console.log(err);
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: SERVICE_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

// Create Service Template
export const create = (formData, history) => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
  dispatch(loadingOnServiceSubmit());
  const config = {
    headers: {
      "Content-Type": "application/json; multipart/form-data;",
    },
  };
  try {
    const data = new FormData();
    for(var i in formData){
      data.append(i, formData[i]);
    }
    const res = await axios.post(
      SERVICE.CREATE().ENDPOINT,
      data,
      config
    );
    if (res.data.status === true) {
      dispatch({
        type: SERVICE_CREATED,
        payload: res.data.response,
      });
      // dispatch({ type: REMOVE_ALERT });
      dispatch(setAlert("Service Template Created.", "success"));
      history("/home/services");
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch(setAlert(res.data.message, "danger"));
        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    // console.log(err);
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: SERVICE_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

// Edit Service Template
export const edit =
  (formData, history, service_id) => async (dispatch) => {
    // -- Always remove the previous errors before sending new request
    dispatch({ type: REMOVE_ERRORS });
    dispatch(loadingOnServiceSubmit());
    const config = {
      headers: {
        "Content-Type": "application/json; multipart/form-data;",
      },
    };
    try {
      const data = new FormData();
      for(var i in formData){
        data.append(i, formData[i]);
      }
      console.log(data);
      const res = await axios.post(
        `${SERVICE.LIST().ENDPOINT}/${service_id}`,
        data,
        config
      );
      if (res.data.status === true) {
        dispatch({
          type: SERVICE_UPDATED,
          payload: res.data.response,
        });
        // dispatch({ type: REMOVE_ALERT });
        dispatch(setAlert("Service Updated.", "success"));
        history("/home/services");
      } else {
        const errors = res.data.errors;
        if (errors) {
          dispatch({ type: SERVICE_ERROR });
          dispatch(setAlert(res.data.message, "danger"));

          errors.forEach((error) => {
            dispatch(setErrorsList(error.msg, error.param));
          });
        }
      }
      return res.data ? res.data : { status: false };
    } catch (err) {
      // console.log(err);
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch({
            type: SERVICE_ERROR,
            payload: {
              msg: err.response.statusText,
              status: err.response.status,
            },
          });
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

// Delete Service Template
export const deleteService =
  (service_id, history) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios.delete(
        `${SERVICE.LIST().ENDPOINT}/${service_id}`,
        config
      );
      // dispatch({ type: REMOVE_ALERT });

      dispatch({
        type: DELETE_SERVICE,
        payload: service_id,
      });
      dispatch(setAlert("Service Template deleted", "success"));
    } catch (err) {
      // console.log(err);
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch({
            type: SERVICE_ERROR,
            payload: {
              msg: err.response.statusText,
              status: err.response.status,
            },
          });
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

//change status
export const changeStatus = (service_id, status) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      `/api/admin/service/change-status/${service_id}`,
      { status },
      config
    );
    // dispatch({ type: REMOVE_ALERT });
    await dispatch({
      type: CHANGE_SERVICE_STATUS,
      payload: res.data.response,
    });
    dispatch(setAlert(res.data.message, "success"));
  } catch (err) {
    // console.log(err);
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: SERVICE_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

// Delete User
export const cancelSave = (history) => async (dispatch) => {
  // dispatch({ type: REMOVE_ALERT });
  dispatch({ type: REMOVE_ERRORS });
  history("/home/services");
};

// Dispatch Loading
export const loadingOnServiceSubmit = () => async (dispatch) => {
  await dispatch({ type: LOADING_ON_SERVICE_SUBMIT });
};

// page not found
export const notFound = (history) => async (dispatch) => {
  history("/home/page-not-found");
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch({ type: SERVICE_ERROR });
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

// Load Page/Show Page
export const loadPage = () => async (dispatch) => {
  await dispatch({ type: LOAD_PAGE });
};

// reset errors
export const removeErrors = () => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
};

// Dispatch Reset store
export const resetComponentStore = () => async (dispatch) => {
  await dispatch({ type: RESET });
};

//update service type
export const updateServiceType = (service_id, serviceType) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      `/admin/service/updateServiceType/${service_id}`,
      { serviceType },
      config
    );
    // dispatch({ type: REMOVE_ALERT });
    await dispatch({
      type: CHANGE_SERVICE_STATUS,
      payload: res.data.response,
    });
    dispatch(setAlert(res.data.message, "success"));
  } catch (err) {
    // console.log(err);
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: SERVICE_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};
